import { BaseFieldClass } from './baseField.class'

import { IStringField } from '@/types/serverField.type'

export class StringFieldClass extends BaseFieldClass {
  declare fieldValue: string
  declare initialValue: string

  constructor (field: IStringField) {
    super(field)
    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value as string | null)
    this.fieldValue = this.prepareValue(value as string | null)
  }

  prepareValue (value: string | null): string {
    return value ?? ''
  }

  getValue (): Record<string, string> {
    return {
      [this.name]: this.fieldValue
    }
  }

  isEmpty (): boolean {
    return this.fieldValue.length === 0
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, String(this.fieldValue ?? ''))
  }

  getFilterValue (): string {
    return this.value === null ? '' : String(this.value)
  }
}
